import React, { useContext } from 'react';
import { Menu } from 'lucide-react';
import { SidebarContext } from '../layouts/DashboardLayout';

function PageHeader({ title, subtitle, actions }) {
  const { onToggle } = useContext(SidebarContext);

  return (
    <header className="flex items-center gap-4 px-6 py-4 border-b border-gray-200 bg-white">
      <button
        onClick={onToggle}
        className="flex-shrink-0 p-1.5 rounded-lg text-gray-500 hover:bg-gray-100 transition-colors"
        aria-label="Toggle sidebar"
      >
        <Menu size={20} />
      </button>
      <div className="flex-1 min-w-0">
        <h1 className="text-lg font-semibold text-gray-900 truncate">{title}</h1>
        {subtitle && <p className="text-sm text-gray-500 truncate">{subtitle}</p>}
      </div>
      {actions && actions.length > 0 && (
        <div className="flex items-center gap-2 flex-shrink-0">
          {actions}
        </div>
      )}
    </header>
  );
}

export default PageHeader;